import { CenterLecComment } from '../../../lib/types/models/center-lec-comment/center-lec-comment'
import { CenterLecCommentInput } from '../../../lib/types/models/center-lec-comment/center-lec-input'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export const createCenterLecComment = async (
  input: CenterLecCommentInput & { centerId: number }
) => {
  const { centerId, ...data } = input

  return restApiClient
    .url(constructApiUrl(API.centers.createCenterLecComment.url, { centerId }))
    .post<CenterLecComment, CenterLecCommentInput>(data)
}
